import * as React from 'react'
import '../styles/App.scss'
import { AddressInfo } from '../types'

interface FormattedAddressprops {
  address: AddressInfo
}

export default class FormattedAddress extends React.Component<FormattedAddressprops, {}> {
  render() {
    return (
      <div className="formatted-address" tabIndex={0} >
        {this.props.address ?
          this.props.address.apartmentNumber ?
            `${this.props.address.streetName}, #${this.props.address.apartmentNumber}`
            :
            `${this.props.address.streetName}`
          : null
        }<br />{
          this.props.address ?
            `${this.props.address.city}, ${this.props.address.region} ${this.props.address.zipCode}`
            : null
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/FormattedAddress.tsx